export const DEFAULT_NO_VALUE_PLACEHOLDER = '–'
